import type { JSX } from 'react';
import { HookFormCheckbox } from 'ts/commons/forms/HookFormCheckbox';
import { FormGroup } from 'ts/components/Form';

/** Values provided by the AddedToTaskFilter component. */
export type AddToTaskFilterValues = {
	/** Added to task filter for this FilterComponent. */
	addedToTaskFilter: boolean;
};

/**
 * Filter that will only include findings with associated tasks. The component will only work when wrapped in a
 * FormProvider.
 */
export function AddedToTaskFilter(): JSX.Element {
	return (
		<FormGroup inline as="fieldset">
			<legend>Tasks</legend>
			<HookFormCheckbox<AddToTaskFilterValues>
				name="addedToTaskFilter"
				id="add-to-task-checkbox"
				label="Show findings added to tasks"
			/>
		</FormGroup>
	);
}
